/* prettier-ignore */

import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToolsService } from 'src/app/services/tools.service';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';
import { RegisterFormService } from 'src/chatbot/service/chat-actions/register-form.service';

@Component({
  selector: 'cicerone-register-step-traveler-type',
  templateUrl: './step-traveler-type.component.html',
  styleUrls: ['./step-traveler-type.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class RegisterTravelerTypeComponent {
    @Output() public travelerTypeEmitter: EventEmitter<any> = new EventEmitter<any>();
    @Input() travellerTypes?:any[] = [];
    public travelerTypeForm: FormGroup;
    
    constructor(
        public translate: TranslateService, 
        public tools: ToolsService, 
        private fb: FormBuilder, 
        private registerFormService: RegisterFormService,
        private routeService: NewCustomRouteService) 
    {
        this.travelerTypeForm = this.fb.group({});
    }

    ngOnInit(){
        this.initForm();
    }

    initForm(){
        this.travelerTypeForm.addControl(`traveler-type`, new FormControl(null, Validators.required));
    }

    setSelectedOption(value){
        this.routeService.routeConfig = { ...this.routeService.routeConfig, travellerType: `${value}` };
        this.registerFormService.setLocalStorageData('group_id', `${value}`);
        this.emitData(value);
    }

    focusin(evt) {
        evt.stopPropagation();
    }

    emitData(id){
        this.travelerTypeEmitter.emit(id);
    }
    
}